function perfil() {
  return import(/* webpackChunkName: "perfil" */ '@/pages/perfil.vue')
}
function unidades__id_index() {
  return import(
    /* webpackChunkName: "unidades-id-index" */ '@/pages/unidades/_id/index.vue'
  )
}
function condominios__id_documentos() {
  return import(
    /* webpackChunkName: "condominios-id-documentos" */ '@/pages/condominios/_id/documentos.vue'
  )
}
function unidades__id_cobrancas() {
  return import(
    /* webpackChunkName: "unidades-id-cobrancas" */ '@/pages/unidades/_id/cobrancas.vue'
  )
}

export default [
  {
    name: 'Perfil',
    path: '/perfil',
    component: perfil,
    meta: {
      hasColoredBackground: true,
    },
  },
  {
    name: 'Unidade',
    path: '/unidades/:id',
    component: unidades__id_index,
  },
  {
    name: 'Documentos',
    path: '/condominios/:id/documentos',
    component: condominios__id_documentos,
  },
  {
    name: 'Cobranças',
    path: '/unidades/:id/cobrancas',
    component: unidades__id_cobrancas,
  },
]
